import React from 'react';
import { createRoot } from 'react-dom/client';
import './bootstrap';

// --- STATIC IMPORTS ---
import TestComponent from './components/TestComponent.jsx';
import ViewList from './components/react/list/ViewList.jsx';
import DataTable from './components/react/data_tables/DataTable.jsx';
import TestComp from './components/react/data_tables/TestComp.jsx'; // Import TestComp directly
import AiChat from './components/react/aichat/AiChat.jsx';
import FolderExplorer from './components/react/folder_explorer/FolderExplorer.jsx'; // Import FolderExplorer
import FileUploader from './components/react/file_uploader/FileUploader.jsx';
import UserProfile from './components/react/user/UserProfile.jsx';
import McpAdminPanel from './components/react/user/McpAdminPanel.jsx';
import BusinessSettings from './components/react/accounts/BusinessSettings.jsx';
import ManualManager from './components/react/manual/ManualManager.jsx';
import NotesBrowser from './components/react/notes/NotesBrowser.jsx';
import WorkflowBoard from './components/react/workflows/WorkflowBoard.jsx';
import AttachmentManager from './components/react/attachments/AttachmentManager.jsx';
import DocumentExplorer from './components/react/attachments/DocumentExplorer.jsx';
import ContentPageEditor from './components/react/webpages/ContentPageEditor.jsx';
import WebpageSettings from './components/react/webpages/WebpageSettings.jsx';
import WebpageImportWizard from './components/react/webpages/WebpageImportWizard.jsx';
import WebpageImportWizardSimple from './components/react/webpages/WebpageImportWizardSimple.jsx';
import WebpageImporterEditor from './components/react/webpages/WebpageImporterEditor.jsx';
import WebpagesBrowserDev from './components/react/webpages/WebpagesBrowserDev.jsx';
import TaskManagementApp from './components/react/tasks/TaskManagementApp.jsx';
import PageEditorController from './components/react/page_builder/PageEditorController.jsx';
import MediaManager from './components/react/media_manager/MediaManager.jsx';
import DashboardStyleGuide from './components/react/styleguide/DashboardStyleGuide.jsx';
import WebTemplateEditorController from './components/react/web_template_editor/WebTemplateEditorController.jsx';
import TemplateImportWizard from './components/react/web_template_editor/TemplateImportWizard.jsx';
import EmailTemplateFallbackEditor from './components/react/EmailTemplateFallbackEditor.jsx';
import EmailEditorMount from './components/react/email_editor/EmailEditorMount.jsx';
import AiConnections from './components/react/mcp/AiConnections.jsx';
import EdenChat from './components/react/ai/EdenChat.jsx';
import AiSettings from './components/react/ai/AiSettings.jsx';

// --- Component mapping (using imported components) ---
const componentRegistry = {
  'test-component': TestComponent,
  'view-lists': ViewList,
  'data-table': DataTable,
  'test-comp': TestComp, // Map the imported component
  'ai-chat-interface': AiChat,
  'folder-explorer': FolderExplorer // Register FolderExplorer
  , 'file-uploader': FileUploader
  , 'user-profile': UserProfile
  , 'mcp-admin-panel': McpAdminPanel
  , 'business-settings': BusinessSettings
  , 'manual-manager': ManualManager
  , 'notes-browser': NotesBrowser
  , 'workflow-board': WorkflowBoard
  , 'attachment-manager': AttachmentManager
  , 'document-explorer': DocumentExplorer
  , 'content-page-editor': ContentPageEditor
  , 'webpage-settings': WebpageSettings
  , 'webpage-import-wizard': WebpageImportWizard
  , 'webpage-import-wizard-simple': WebpageImportWizardSimple
  , 'webpage-importer-editor': WebpageImporterEditor
  , 'webpages-browser-dev': WebpagesBrowserDev
  , 'task-management-app': TaskManagementApp
  , 'page-editor-controller': PageEditorController
  , 'media-manager': MediaManager
  , 'dashboard-style-guide': DashboardStyleGuide
  , 'web-template-editor-controller': WebTemplateEditorController
  , 'web-template-import-wizard': TemplateImportWizard
  , 'email-template-fallback-editor': EmailTemplateFallbackEditor
  , 'email-editor': EmailEditorMount
  , 'ai-connections': AiConnections
  , 'eden-chat': EdenChat
  , 'ai-settings': AiSettings
};

console.log('React app initializing');

document.addEventListener('DOMContentLoaded', () => { // Removed async
  console.log('DOM loaded, looking for React mount points');
  const mountPoints = document.querySelectorAll('[data-react-component]');
  console.log(`Found ${mountPoints.length} React mount points`);

  for (const mountPoint of mountPoints) {
    try {
      const componentName = mountPoint.dataset.reactComponent;
      console.log(`Processing mount point for component: ${componentName}`);
      const props = mountPoint.dataset.props ? JSON.parse(mountPoint.dataset.props) : {};

      // --- Use statically imported component ---
      if (componentRegistry[componentName]) {
        const Component = componentRegistry[componentName]; // Get the component directly

        console.log(`Rendering component: ${componentName}`);
        const root = createRoot(mountPoint);
        root.render(<Component {...props} />);

      } else {
        console.error(`Unknown React component: ${componentName}`);
        mountPoint.innerHTML = `<div style="color: red; padding: 10px; border: 1px solid red;">Error loading component: ${componentName}</div>`;
      }
    } catch (error) {
      console.error('Error processing React mount point:', error);
      mountPoint.innerHTML = `<div style="color: red; padding: 10px; border: 1px solid red;">React component error: ${error.message}</div>`;
    }
  }

  // ... (rest of the code, debugElement etc.)
  const debugElement = document.getElementById('react-debug');
  if (debugElement) {
    console.log('Debug element found, rendering test content');
    try {
      const debugRoot = createRoot(debugElement);
      debugRoot.render(<div>React is working! Mount points found: {mountPoints.length}</div>);
    } catch (error) {
      console.error('Error rendering debug element:', error);
      debugElement.innerHTML = `<div style="color: red;">Error initializing React: ${error.message}</div>`;
    }
  }
});
